export const SolidType = {
  VTK_SOLID_TETRAHEDRON: 0,
  VTK_SOLID_CUBE: 1,
  VTK_SOLID_OCTAHEDRON: 2,
  VTK_SOLID_ICOSAHEDRON: 3,
  VTK_SOLID_DODECAHEDRON: 4,
};

export default {
  SolidType,
};
